module.exports = __webpack_public_path__ + "static/img/floor-map.8206e26.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/floor-map.png
// module id = Cpyn
// module chunks = 1